import { API_ENDPOINT_GET_INVITES } from "src/helpers/endpoint-urls";
import apiClient from "../helpers/api-client";

export const getAllInvites = async () => {
  try {
    return await apiClient.get(API_ENDPOINT_GET_INVITES);
  } catch (_e) {
    throw _e;
  }
};
